import styled from '@emotion/styled';
import { darken } from 'polished';
import React, { CSSProperties, forwardRef, ReactNode } from 'react';
import { FC } from 'react';
import FontAwesome from './FontAwesome';
import theme from './theme';

const scale = (value: number) => (props: ButtonProps) => {
    if (props.small) return 0.8 * value;
    if (props.large) return 1.3 * value;
    return value;
};

const color = (props: ButtonProps) => {
    if (props.primary) return theme.primary;
    if (props.destructive) return theme.danger;
    if (props.color) return props.color;
    if (props.darkGrey) return theme.darkGrey;
    return theme.tertiary;
};

type ButtonProps = {
    color?: string;
    destructive?: boolean;
    darkGrey?: boolean
    primary?: boolean;
    small?: boolean;
    large?: boolean;
    loading?: boolean;
    onClick?: () => void;
    style?: CSSProperties;
    disabled?: boolean;
    children?: ReactNode;
    ['data-testid']?:string;
};


const Button = styled.button<ButtonProps>`
    :first-letter {text-transform: uppercase}
    color: white;
    background-color: ${color};

    border: none;
    padding-top: ${(props) => scale(10)(props)}px;
    padding-bottom: ${(props) => scale(10)(props)}px;
    padding-left: ${(props) => scale(20)(props)}px;
    padding-right: ${(props) => scale(20)(props)}px;
    border-radius: 4px;

    box-shadow: 0 2px 5px 1px rgba(150, 150, 150, 0.5);

    font-weight: 500;
    font-size: ${(props) => scale(1)(props)}em;

    transition: all 150ms ease-in-out;

    &:hover {
        background-color: ${(props) => darken(0.05, color(props))};
        box-shadow: 0 2px 5px 2px rgba(150, 150, 150, 0.5);
    }

    &:hover,
    &:active,
    &:focus {
        color: white;
    }

    &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }
`;

const CustomButton = forwardRef<HTMLButtonElement, ButtonProps>(({ loading, children, ...rest }, ref) => (
    <Button {...rest} ref={ref}>
        {
            loading
                ? < FontAwesome icon="spinner-third" weight="duotone" spin />
                : children
        }
    </Button>
))

export default CustomButton;
